import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowNarrowTopAlign = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.33268 8L7.99935 5.33334M7.99935 5.33334L10.666 8M7.99935 5.33334V13.3333M2.66602 2.66667H13.3327",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowNarrowTopAlign;
